export const ERROR_CHECK_USER_PROBLEM = Object.freeze({
  notPhone: 'Поле Телефон обязательно для заполнения',
  notStringPhone: 'Поле Телефон должно быть строкой',
  phoneTooLong: 'Некорректный номер телефона',
  tryLater: 'Попробуйте позже или обратитесь в клиентскую службу',
});

export const ERROR_CAPTCHA = Object.freeze({
  notStringCaptchaToken: 'CaptchaToken должен быть строкой',
  emptyCaptchaToken: 'CaptchaToken не должен быть пустым',
  notStringCaptchaAction: 'CaptchaAction должен быть строкой',
  emptyCaptchaAction: 'CaptchaAction не должен быть пустым',
  notStringCaptchaVersion: 'CaptchaVersion должен быть строкой',
  emptyCaptchaVersion: 'CaptchaVersion не должен быть пустым',
});

export const ERROR_CALL_ORDER = Object.freeze({
  notStringPhone: 'Поле Телефон должен быть строкой',
  emptyPhone: 'Поле Телефон не должен быть пустым',
});

export const ERROR_USER_PASSWORD_RECOVERY = Object.freeze({
  notLogin: 'Поле Email обязательно для заполнения',
  notStringLogin: 'Поле Email должно быть строкой',
  notPhone: 'Поле Телефон обязательно для заполнения',
  notStringPhone: 'Поле Телефон должно быть строкой',
});

/**
 * Невалидный адрес электронной почты при проверке email на доступность
 * @type {string}
 */
export const NO_VALID_EMAIL_AVAILABILITY = 'e1420a46-7bf6-44cf-8723-7e57e4925236';
